import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/apiConfig';
import { IAvailableModulesByWorker } from './moduleAllType';

const availableModulesUrl = '/csb/modules/available';

const fetchAvailableModulesByWorker = async (): Promise<IAvailableModulesByWorker> => {
  const response = await apiClient.get<IAvailableModulesByWorker>(
    availableModulesUrl
  );
  return response.data;
};

export const useAvailableModulesByWorker = () =>
  useQuery<IAvailableModulesByWorker>({
    queryFn: fetchAvailableModulesByWorker,
    queryKey: ['available-modules-by-worker'],
  });
